<template>
  <div class="approved_box">
    <ax-result-page v-if="showResult" type="network" subtext="要不然下拉刷新试试？" ></ax-result-page>
    <div v-if="!showResult&&showContent">
      <div class='number already-number'>单号：{{data.工单ID}}</div>
      <ax-panel title="审批单信息">
        <van-cell v-for="(item,key) in data" :key="key" :title="key">
            <b class="content_box" v-html="item"></b>
        </van-cell>
      </ax-panel>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { fetchData } from '@/api/hulk'

  export default {
    name: 'hulkEndDetails',
    data() {
      return {
        id: this.$route.query.id,
        data: {},
        opinion: '',
        showResult: false,
        showContent:false,
        toast: null
      }
    },
    created() {
      this.toast = this.$toast.loading({mask: false,message: '加载中...',duration: 0});
      this.getDetailsData();
    },
    methods: {
      getDetailsData() {
        fetchData('getDetail',{
            "apply_id": this.id
        }).then(response => {
          this.toast.clear();
          if(response.data.errno === 0) {
            this.data = response.data.data;
            this.showContent = true;
          }else{
            this.showResult = true;
          }
        }).catch(() => {
          this.toast.clear();
          this.showResult = true;
        });
      }
    },
    beforeDestroy() {
      this.toast.clear()
    }
  }
</script>
